import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import LinkIcon from "@mui/icons-material/Link";
import { TablePagination } from "@mui/material";

function JobRow(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowRight />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {row.title}
        </TableCell>
        <TableCell align="center">
          <a href={row.applyUrl} target="_blank" rel="noopener noreferrer">
            <LinkIcon />
          </a>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h5" gutterBottom component="div">
                Description
              </Typography>
              <div dangerouslySetInnerHTML={{ __html: row.description }} />
              <div dangerouslySetInnerHTML={{ __html: row.requirements }} />


              {row.salaryDescription && <><hr /><Typography variant="h5" gutterBottom component="div" dangerouslySetInnerHTML={{ __html: `Compensation: ${row.salaryDescription}` }}>
              </Typography>              </>}

              {row?.location.name !== 'Unspecified' && <><hr /><Typography variant="h5" gutterBottom component="div">
                Location
              </Typography>
                {row.location.name && <><span>Office:&nbsp;{row.location.name}</span><br /></>}
                {row.location.address && <><span>Address:&nbsp;{row.location.address}</span> <br /></>}
                {row.location.city && <> <span>City:&nbsp;{row.location.city}</span> <br /></>}
                {(row.location.state || row.location.metro) && <> <span>
                  State:&nbsp;{row.location.state} {row.location.metro}
                </span>
                  <br /></>}
              </>}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function createJobRow(job, id) {
  return {
    jobId: job.jobId * id,
    title: job.title,
    companyName: job.companyName,
    applyUrl: job.applyUrl,
    location: job.jobLocation,
    requirements: job.requirements,
    salaryDescription: job.salaryDescription,
    hiringDepartment: job.hiringDepartment,
    description: job.description
  };
}
JobRow.propTypes = {
  row: PropTypes.shape({
    jobId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    applyUrl: PropTypes.string.isRequired,
    location: PropTypes.shape({
      name: PropTypes.string,
      address: PropTypes.string,
      address2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
      metro: PropTypes.string,
      locationDisplayName: PropTypes.string,
    }).isRequired,
    requirements: PropTypes.string.isRequired,
    salaryDescription: PropTypes.string.isRequired,
    hiringDepartment: PropTypes.string.isRequired,
  }).isRequired,
};

export default function JobTable({ jobs }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const rows = jobs.map((_, id) => createJobRow(_, id));
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <TableContainer component={Paper}>
      <Table stickyHeader aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell align="center">Title</TableCell>
            {/* <TableCell align="center">Company Name</TableCell> */}
            <TableCell align="center">Apply</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
              <JobRow key={row.jobId} row={row} />
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}
